<!-- 我的页面 -->
<template>
  <!-- <swiper class="my-swiper" :options="swiperOption" v-show="returnData_new.display"> -->
  <!-- <div class="swiper-container" v-show="returnData_new.display"> -->
  <div>
    <div
      v-bind:class="['swiper-container', 'swiper-container-'+componentIndex]"
      v-bind:id="['swiper-container-'+componentIndex]"
      v-show="returnData_new.display"
    >
      <div ref="swiper_wrapper_ref" class="swiper-wrapper">
        <div
          class="swiper-slide"
          v-for="(item,index) in returnData_new.nextDetailsDTOs"
          :key="index"
        >
          <div
            class="auto-height default"
            :style="{height:getSwiperHeight()+'px'}"
            v-if="!item.urls[item.urls.length-1]"
          >
            <img class="deaultimg" src="@/assets/image/tbm/defaultsmallicon.png" />
          </div>
          <!-- </div> -->
          <div class="inforwrap" v-else>
            <div
              :class="['auto-height img-cover',item.imgLoaded ?'imgloaded':'']"
              @click="goPage(item,'',index)"
            >
              <div class="text-info">
                <div class="des">{{item.description}}</div>
                <div
                  class="btns"
                  @click.stop="goPage(item,'btn',index)"
                  v-show="item.buttonDisplay =='DISPLAY'&&item.buttonText"
                >{{item.buttonText}}</div>
              </div>
              <template v-if="item.urlType=='IMAGE'">
                <img class="info_img" :src="replaceImg(item.urls[item.urls.length-1])" />
              </template>

              <template v-if="item.urlType=='VIDEO'">
              
                <video-mobile
                  :showControls="false"
                  :ref="`children${componentIndex}`"
                  :showCom="'carouselPoster'"
                  :imgLoaded="item.imgLoaded"
                  :video-height="clientHeightForSwiper"
                  :component-index="componentIndex"
                  :item-index="index"
                  :source-data="item.urls[item.urls.length-1]"
                  :use-video-controller="item.playerControl != 'HIDE'"
                ></video-mobile>
                <!-- <img v-else style="width:100%;height:100%" :src="item.urls[0]+videoStr" /> -->
              </template>
            </div>
          </div>
        </div>
        <!-- 如果需要分页器自定义 由于动态加载数据 一直不出来 -->
        <div class="custom-paginations" v-if="returnData_new.nextDetailsDTOs.length>1">
          <li
            :class="['pagination-item',changeindex == pindex ? 'pagination-item-active':'']"
            v-for="(pa,pindex) in returnData_new.nextDetailsDTOs"
            :key="pindex"
          ></li>
        </div>
        <!-- <div
        v-bind:class="['swiper-pagination', 'swiper-pagination-'+componentIndex]"
        slot="pagination"
        ></div>-->
      </div>
    </div>
  </div>
  <!-- </swiper> -->
</template>

<script>
// 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
// 例如：import 《组件名称》 from '《组件路径》'
import Swiper from "swiper";
import { checkLinkUrl } from "../../../utils/utils";
import VideoMobile from "./VideoMobile";
export default {
  // import引入的组件需要注入到对象中才能使用
  name: "CarouselPoster",
  components: { VideoMobile },
  props: {
    returnData: {
      type: Object,
      required: false
    },
    componentIndex: {
      type: Number,
      required: true
    }
  },
  data() {
    // 这里存放数据
    return {
      ossSuffix:this.$store.state.ossSuffix,
      ossSuffixOriginSuff:this.$store.state.ossSuffixOriginSuff,
      videoStr: "?vframe/jpg/offset/2",
      isWechatLike: false,
      changeindex: 0,
      desinfo: "我是测试标题",
      title: "今日之时",
      playingVideo: false,
      voiceOff: true,
      currentTimeString: "00:00",
      currentTime: 0,
      totalTimeString: "00:00",
      totalTime: 0,
      timeLineClientX: 0,
      dragging: false,
      fullScreen: false,
      showBottomController: false,
      clientHeightForSwiper: null,
      videoHeight: 0
    };
  },
  // 监听属性 类似于data概念
  computed: {},
  // 监控data中的数据变化
  watch: {
    returnData: {
      dragging: false,
      immediate: true,
      handler(val, oldVal) {
        this.returnData_new = val;
        if (this.returnData.display) {
          // let i = 0;
          // if (!this.returnData_new.nextDetailsDTOs[i].imgLoaded) {
          //   this.loaded(i);
          // }
        }
      },
      deep: true //true 深度监听
    },
    // "$store.state.screenWidth": {
    //   immediate: true,
    //   handler(val) {
    //     for (let i = 0; i < this.returnData_new.nextDetailsDTOs.length; i++) {
    //       if (this.returnData_new.nextDetailsDTOs[i].urlType == "IMAGE") {
    //         let imageData = this.returnData_new.nextDetailsDTOs[i].urls;
    //         if (imageData[0]) {
    //           let image = new Image();
    //           image.onload = () => {
    //             let rate = image.width / image.height;
    //             this.clientHeightForSwiper = window.innerWidth / rate;
    //           };
    //           image.src = imageData[0];
    //           break;
    //         } else {
    //           this.clientHeightForSwiper = 468;
    //         }
    //       }
    //     }
    //   }
    // },

    componentIndex(newVal) {
      
    }
  },
  mounted() {
    if(this.$utils.isMobile()){
      this.ossSuffix = "?x-oss-process=style/tb_mobilehp_cd_700"; 
    }
    var that = this;
    this.version = this.$utils.versions();
    if (this.version.u.indexOf("iPhone") > -1) {
      if (this.version.u.indexOf("Safari") == -1) {
        this.isWechatLike = true;
      }
    } else if (this.version.u.indexOf("Mobile") > -1) {
      //安卓
      this.isWechatLike = true;
    }

    //  需要在数据更新之后调用
    this.$nextTick(() => {
      if (this.returnData_new.display) {
        let i = 0;
        if (!this.returnData_new.nextDetailsDTOs[i].imgLoaded) {
          this.loaded(i);
        }
      }

      for (let i = 0; i < this.returnData_new.nextDetailsDTOs.length; i++) {
        if (this.returnData_new.nextDetailsDTOs[i].urlType == "IMAGE") {
          let imageData = this.returnData_new.nextDetailsDTOs[i].urls;
          if (imageData[0]) {
            let image = new Image();
            image.onload = () => {
              let rate = image.width / image.height;
              this.clientHeightForSwiper = window.innerWidth / rate;
            };
            let flag = that.$utils.checkIsUpdatetoWebp(this, imageData[0]); 
            if (flag) {
              image.src = this.$utils.replaceImage( imageData[0] ) + that.ossSuffix;
            } else {
              image.src = this.$utils.replaceImage( imageData[0] ) + that.ossSuffix + that.ossSuffixOriginSuff
            }
            break;
          } else {
            this.clientHeightForSwiper = 468;
          }
        }
      }

      // for (let i = 0; i < this.returnData_new.nextDetailsDTOs.length; i++) {
      //   if (this.returnData_new.nextDetailsDTOs[i].urls) {
      //     let imageData = this.returnData_new.nextDetailsDTOs[i].urls;

      //     if (imageData[0]) {
      //       this.$nextTick(() => {
      //         var img = document.getElementsByClassName("info_img")[0].width;
      //         let widthHeightRate =
      //           document.getElementsByClassName("info_img")[0].width /
      //           document.getElementsByClassName("info_img")[0].height;
      //         var clientWidth =
      //           document.getElementsByClassName("swiper-container")[0]
      //             .clientWidth + 38;
      //         this.clientHeightForSwiper = clientWidth / widthHeightRate;
      //         // if (this.clientHeightForSwiper > 0) {
      //         //   this.clientHeightForSwiper = this.clientHeightForSwiper;
      //         // }
      //         // setTimeout(() => {}, 300);
      //       });
      //       break;
      //     } else {
      //       this.clientHeightForSwiper = 468;
      //     }
      //   }
      // }
      var mySwiper = new Swiper("#swiper-container-" + this.componentIndex, {
        pagination: {
          el: ".swiper-pagination",
          clickable: true
        },
        observer: true, // 监听动态加载 dom 结构
        observeParents: true,
        observeSlideChildren: true,

        effect: "fade", //定义淡入淡出效果
        fadeEffect: {
          crossFade: true
        },
        on: {
          slideChangeTransitionEnd: () => {
            //切换结束时，告诉我现在是第几个slide
            if (mySwiper) {
              this.changeindex = mySwiper.realIndex;
              console.log(mySwiper.realIndex, "99999");
            }
          }
        },
        //speed是一张图划过的时间长度
        speed: 300
      });
    });

    // window.onresize = () => {
    //   for (let i = 0; i < this.returnData_new.nextDetailsDTOs.length; i++) {
    //     if (this.returnData_new.nextDetailsDTOs[i].urlType == "IMAGE") {
    //       let imageData = this.returnData_new.nextDetailsDTOs[i].urls;
    //       if (imageData[0]) {
    //         let image = new Image();
    //         image.onload = () => {
    //           let rate = image.width / image.height;
    //           this.clientHeightForSwiper = window.innerWidth / rate;
    //         };
    //         image.src = imageData[0];
    //         break;
    //       } else {
    //         this.clientHeightForSwiper = 468;
    //       }
    //     }
    //   }
    //   // for (let i = 0; i < this.returnData_new.nextDetailsDTOs.length; i++) {
    //   //   if (this.returnData_new.nextDetailsDTOs[i].urls) {
    //   //     let imageData = this.returnData_new.nextDetailsDTOs[i].urls;
    //   //     if (imageData[0]) {
    //   //       this.$nextTick(() => {
    //   //         var img = document.getElementsByClassName("info_img")[0].width;
    //   //         let widthHeightRate =
    //   //           document.getElementsByClassName("info_img")[0].width /
    //   //           document.getElementsByClassName("info_img")[0].height;
    //   //         this.clientHeightForSwiper =
    //   //           document.getElementsByClassName("swiper-container")[0]
    //   //             .clientWidth / widthHeightRate;
    //   //       });
    //   //       break;
    //   //     } else {
    //   //       this.clientHeightForSwiper = 468;
    //   //     }
    //   //   }
    //   // }
    // };

    // this.$nextTick(() => {
    //   const playerLive = document.getElementById(
    //     "mobileVideo" + this.componentIndex
    //   );
    //   if (!playerLive) {
    //     return;
    //   }
    //   playerLive.addEventListener("loadedmetadata", () => {
    //     this.totalTime = playerLive.duration;
    //     this.totalTimeString = this.formatTime(playerLive.duration);
    //   });
    //   playerLive.addEventListener("timeupdate", () => {
    //     this.currentTime = playerLive.currentTime;
    //     this.currentTimeString = this.formatTime(playerLive.currentTime);
    //   });
    //   playerLive.addEventListener("play", () => {
    //     this.playingVideo = true;
    //   });
    //   playerLive.addEventListener("pause", () => {
    //     this.playingVideo = false;
    //   });
    // });
  },

  // 生命周期 - 创建完成（可以访问当前this实例）
  created() {},

  methods: {
    replaceImg(src){
      if(src.indexOf('x-oss-proces')!=-1){
        return src;
      }
      let flag = this.$utils.checkIsUpdatetoWebp(this, src);
      if (flag) {
        return this.$utils.replaceImage( src ) + this.ossSuffix;
      } else {
        return this.$utils.replaceImage( src ) + this.ossSuffix + this.ossSuffixOriginSuff
      }
    },

    loaded(i) {
      var temp = JSON.stringify(this.returnData_new);
      let item = JSON.parse(temp).nextDetailsDTOs[i];
      if (item.urlType == "VIDEO") {
        if (this.isWechatLike) {
          this.videoLoadedAfter(i);
        } else {
          this.loadVideo(i, item.urls[0]);
        }
      } else {
        this.loadImages(i, item.urls[0]);
      }
    },

    videoLoadedAfter(i, src) {
      //console.log("视频加载完成:" + src);
      this.$set(this.returnData_new.nextDetailsDTOs[i], `imgLoaded`, true);
      if (i == 0) {
        this.$emit("loadingFun");
      }

      let count = i + 1;
      if (count < this.returnData_new.nextDetailsDTOs.length) {
        this.loaded(count);
      }
    },
    loadVideo(i, src) {
      console.log("src" + src);
      const myvideo = document.createElement("VIDEO");
      // 方法一
      var that = this;
      let image = new Image();
      image.onload = () => {
        let rate = image.width / image.height;
        this.clientHeightForSwiper = window.innerWidth / rate;
        that.videoLoadedAfter(i, src);
      };
      image.src = src + this.videoStr;
      // 打印
      myvideo.src = src;
      myvideo.load();

      // 方法二
      // console.log("myvideo", myvideo);
      // ondurationchange
      // myvideo.addEventListener("canplay", event => {
      //   console.log("canplay" + src);
      //   this.videoLoadedAfter(i, src);
      // });
      // myvideo.addEventListener("stalled", event => {
      //   console.log("stalled");
      //   this.videoLoadedAfter(i, src);
      // });
      // myvideo.addEventListener("error", event => {
      //   console.log("视频加载出错啦");
      //   this.videoLoadedAfter(i, src);
      // });
      // myvideo.src = src;
      // myvideo.load();
    },
    loadImages(i, imgsec) {
      // console.log("loadImages", i);
      var that = this;
      let img = new Image();
      img.onload = function() {
        //检测是否支持webp格式
        let flag = that.$utils.checkIsUpdatetoWebp(this, imgsec);
        if (flag) {
          let temp = JSON.stringify(that.returnData_new);
          let urls = JSON.parse(temp).nextDetailsDTOs[i].urls;
          urls[0] = that.$utils.replaceImage( urls[0]) + that.ossSuffix;
          that.$set(that.returnData_new.nextDetailsDTOs[i], `urls`, urls);
        }
        // console.log("loadImages:", i);
        let data = that.returnData_new.nextDetailsDTOs[i];
        that.$set(data, `imgLoaded`, true);
        if (i == 0) that.$emit("loadingFun");

        let count = i + 1;
        if (count < that.returnData_new.nextDetailsDTOs.length) {
          that.loaded(count);
        }
      };
      img.onerror = function() {
        let data = that.returnData_new.nextDetailsDTOs[i];
        that.$set(data, `imgLoaded`, true);
        if (i == 0) that.$emit("loadingFun");
        let count = i + 1;
        if (count < that.returnData_new.nextDetailsDTOs.length) {
          that.loaded(count);
        }
      };
      let imgsec2 = that.returnData_new.nextDetailsDTOs[i].urls[0];
      let flag = that.$utils.checkIsUpdatetoWebp(this, imgsec2);
      if (flag) {
        img.src = this.$utils.replaceImage( that.returnData_new.nextDetailsDTOs[i].urls[0] ) + that.ossSuffix;
      } else {
        img.src = this.$utils.replaceImage( that.returnData_new.nextDetailsDTOs[i].urls[0] ) + that.ossSuffix + that.ossSuffixOriginSuff
      }
    },
    getSwiperHeight() {
      console.log(this.clientHeightForSwiper);
      return this.clientHeightForSwiper;
    },
    doShowBottomClick() {
      this.showBottomController = true;
      if (this.timeout) {
        clearTimeout(this.timeout);
      }
      this.timeout = setTimeout(() => {
        this.showBottomController = false;
      }, 3000);
    },
    exitFullScreen() {
      if (document.exitFullscreen) {
        document.exitFullscreen();
      } else if (document.mozCancelFullScreen) {
        document.mozCancelFullScreen();
      } else if (document.webkitExitFullscreen) {
        document.webkitExitFullscreen();
      }
    },
    fullScreenClick() {
      if (document.fullscreenElement) {
        this.fullScreen = true;
      } else {
        this.fullScreen = false;
      }
      let player = document.getElementById("mb_fullscreen");
      if (this.fullScreen) {
        this.exitFullScreen();
        this.fullScreen = false;
      } else {
        this.fullScreen = true;
        player.requestFullscreen();
      }
    },
    voiceOnOrOff() {
      this.voiceOff = !this.voiceOff;
    },
    playOrPauseClick() {
      const playerLive = document.getElementById(
        "mobileVideo" + this.componentIndex
      );
      if (this.playingVideo) {
        playerLive.pause();
      } else {
        playerLive.play();
      }
    },
    seekStart(event) {
      this.dragging = true;
      let timeLineClientX = this.$refs.mb_time_line[0].getBoundingClientRect()
        .x;
      let position = event.changedTouches[0].clientX - timeLineClientX;
      if (position < 0) {
        position = 0;
      }
      const playerLive = document.getElementById(
        "mobileVideo" + this.componentIndex
      );
      playerLive.currentTime =
        (this.totalTime * position) / this.$refs.mb_time_line[0].clientWidth;
      this.doShowBottomClick();
    },
    seekMove(event) {
      if (!this.dragging) {
        return;
      }
      let timeLineClientX = this.$refs.mb_time_line[0].getBoundingClientRect()
        .x;
      let position = event.changedTouches[0].clientX - timeLineClientX;
      if (position < 0) {
        position = 0;
      }
      const playerLive = document.getElementById(
        "mobileVideo" + this.componentIndex
      );
      playerLive.currentTime =
        (this.totalTime * position) / this.$refs.mb_time_line[0].clientWidth;
      this.doShowBottomClick();
    },
    seekEnd(event) {
      this.dragging = false;
    },
    formatTime(value) {
      let result = parseInt(value);
      let h =
        Math.floor(result / 3600) < 10
          ? "0" + Math.floor(result / 3600)
          : Math.floor(result / 3600);
      let m =
        Math.floor((result / 60) % 60) < 10
          ? "0" + Math.floor((result / 60) % 60)
          : Math.floor((result / 60) % 60);
      let s =
        Math.floor(result % 60) < 10
          ? "0" + Math.floor(result % 60)
          : Math.floor(result % 60);
      result = `${h}:${m}:${s}`;
      return result;
    },
    getPlayedWidth() {
      if (this.$refs.mb_time_line && this.$refs.mb_time_line[0]) {
        let width =
          this.$refs.mb_time_line[0].clientWidth *
          (this.currentTime / this.totalTime);
        return width;
      }
      return 0;
    },
    getNotPlayWidth() {
      if (this.$refs.mb_time_line && this.$refs.mb_time_line[0]) {
        let width =
          this.$refs.mb_time_line[0].clientWidth *
          (this.currentTime / this.totalTime);
        return this.$refs.mb_time_line[0].clientWidth - width;
      }
      return 0;
    },
    btnGoPage(item) {
      this.menuShow = false;
  
      var that = this;
      if (item.buttonLink) {
        let params = {
          link: item.buttonLink
        };
        checkLinkUrl(function(data) {}, params, that);
      }
    },
    goPage(item, type,index) {
      this.isweixinenv=this.$utils.isWeixin();
      if(this.isweixinenv){
        this.$nextTick(()=>{
         console.log(this.$refs[`children${index}`][0])
         this.$refs[`children${index}`][0].goPlayVideo(index)
        })
      }
      if (item.urlType == "IMAGE" || type == "btn") {
        //只有图片轮播支持外层的跳转
        this.menuShow = false;
        var that = this;
        if (item.linkUrl) {
          let params = {
            link: item.linkUrl
          };
          checkLinkUrl(function(data) {}, params, that);
        }
      }
    }
  },
  // 生命周期 - 挂载完成（可以访问DOM元素）
  beforeCreate() {}, // 生命周期 - 创建之前
  beforeMount() {}, // 生命周期 - 挂载之前
  beforeUpdate() {}, // 生命周期 - 更新之前
  updated() {}, // 生命周期 - 更新之后
  beforeDestroy() {}, // 生命周期 - 销毁之前
  destroyed() {}, // 生命周期 - 销毁完成
  activated() {} // 如果页面有keep-alive缓存功能，这个函数会触发
  // 方法集合
};
</script>

<style lang='less' scoped>
.ndeooo {
  display: none;
}
//@import url(); 引入公共css类
.swiper-container {
  // width: 100%;
  // height: 100%;
  margin-bottom: 2.8rem;
}
.deaultimgwrap {
  width: 100%;
  height: 100%;
  background: #e3f0ff;
  position: relative;
}
.deaultimg {
  width: 35px;
  height: 35px;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  margin: auto;
}
.inforwrap {
  width: 100%;
  // height: 100%;
}
.mb-bottom-control-box {
  padding: 0.1rem 0.5rem 0;
  width: 100%;
  position: absolute;
  bottom: 2.5rem;
  left: 0;
  display: flex;
  flex-direction: row;
  align-items: center;
  height: 3.6rem;
  z-index: 2147483647;
  transition: opacity 0.5s;
  background-color: rgba(34, 34, 34, 0.7);
  .mb-video-icon {
    display: flex;
    flex-direction: column;
    justify-content: center;
    width: 1.5rem;
    height: 3.5rem;
    margin: 0 0.8rem;
    img {
      height: 1.8rem;
      width: 1.5rem;
    }
  }
  .mb-time-box {
    color: #fff;
    font-size: 1.3rem;
    margin: 0 0.8rem;
  }
  .mobile-video-icon {
    width: 2rem;
    img {
      height: 1.8rem;
      width: 2rem;
    }
  }
  .mb-time-line-box {
    display: flex;
    flex-direction: row;
    width: 0;
    height: 100%;
    display: flex;
    flex-direction: row;
    align-items: center;
    flex-grow: 1;
    .mb-time-line-played {
      height: 0.3rem;
      pointer-events: none;
      background-color: #fff;
    }
    .mb-seekingBox {
      width: 0.2rem;
      height: 1.1rem;
      background-color: #fff;
    }
    .mb-time-line-not-played {
      height: 0.3rem;
      flex: 1;
      background-color: hsla(0, 0%, 100%, 0.4);
    }
  }
}
.mb-bottom-control-box-show {
  opacity: 1 !important;
}
.mb-bottom-control-box-hide {
  opacity: 0 !important;
}
.info_img {
  width: 100%;
  // height: 100%;
  // object-fit: cover;
}
.info_video {
  width: 100%;
  // height: 100%;
}
/deep/ video {
  object-fit: fill;
}
.img-cover {
  // opacity: 0;
  // &.imgloaded {
  //   opacity: 1;
  //   transition: opacity 0.3s ease-in-out 0.3s;
  // }
}

.auto-height {
  display: block;
  width: 100%;
  min-height: 0;
  height: auto;
  // height: 0;
  // padding-bottom: 156%;
  background: center no-repeat #ffffff;
  background-size: contain;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  &.default {
    background: #e3f0ff;
  }
  &:hover {
    filter: initial;
  }

  .text-info {
    width: 80%;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    font-size: 2rem;
    font-family: ArialNarrow;
    z-index: 9;
    .des {
      width: initial;
      // width:100px;
      // word-break: keep-all;
      // white-space: nowrap;
      // overflow: hidden;
      // text-overflow: ellipsis;
      color: white;
      text-align: center;
      margin: 0 auto 1rem;
    }
    .btns {
      border: 0.2rem solid white;
      color: white;
      padding: 0.5rem 2.4rem 0.3rem;
      line-height: 1.667;
      width: fit-content;
      margin: 0 auto;
    }
  }
  .banner-img {
    min-height: 3rem;

    max-width: 100%;
    vertical-align: middle;
    object-fit: cover;
  }
}
@media screen and (max-width: 1024px) {
  .auto-height {
    // padding-bottom: 100%;
  }
}
@media screen and (max-width: 768px) {
  .auto-height {
    // padding-bottom: 150%;
  }
}
/deep/.swiper-pagination-bullet {
  width: 3rem;
  height: 0;
  background-color: transparent;
  border: 1px solid rgba(255, 255, 255, 0.4);
  margin: 0 0.25rem;
}
/deep/.swiper-pagination-bullet-active {
  width: 3rem;
  height: 0;
  background-color: transparent;
  border: 1px solid white;
  border-radius: 0 !important;
}
/deep/.swiper-pagination {
  left: 0;
  right: 0;
  bottom: 6.6rem;
}
/deep/.custom-paginations {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 6.6rem;
  display: flex;
  justify-content: center;

  .pagination-item {
    width: 3rem;
    height: 0;
    background-color: transparent;
    border: 1px solid rgba(255, 255, 255, 0.4);
    margin: 0 0.25rem;
  }
  .pagination-item-active {
    width: 3rem;
    height: 0;
    background-color: transparent;
    border: 1px solid white;
    border-radius: 0 !important;
  }
}
.my-swiper {
  padding-bottom: 2.8rem;
}
.swiper-wrapper {
  height: auto;
}
</style>



// WEBPACK FOOTER //
// src/components/common/customize/CarouselPoster.vue